import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DataTransferService } from '../../services/DataTransferService';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'drop-down-List',
  templateUrl: './drop-down-list.html',
  styleUrls: ['./drop-down-list.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({


        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class DropDownListComponent implements OnInit, OnChanges, AfterViewInit {
  country;
@ViewChild('searchInput') searchInput: ElementRef;
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.label == "Country") {
        this.data.countryTypeSource.subscribe(x => this.country = x);
        if (this.country != "default message" && this.country != null) {
          this.searchTerm = this.country;
          this.search(this.searchTerm);
          var country = this.tempContent[0];
          this.selectCountryDDL(country);
        }
      }
    }, 500)

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedEl != null) {
      this.selectedValue.key = this.selectedEl.key
      this.isOpen = false;
    }
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true)
        this.isOpen = true;
    }
  }

  @Input() enableChange;
  @Input() changing: boolean;
  @Input() label: string;
  @Input("ddlContent") ddlContent: any;
  @Input("selectedEl") selectedEl: any;
  tempContent = [];
  @Output() dllObject = new EventEmitter();
  @Output() isEnableSelectPostalCode = new EventEmitter();
  @Output() isEnableSelectCity = new EventEmitter();
  @Output() isEnableSelectProductType = new EventEmitter();
  @Input() initialValue;
  @Output() changeing: boolean;
  showDdl: boolean;
  isOpen: boolean = true;
  searchTerm: string = "";
  selectedValue: any = {};
  constructor(private data: DataTransferService, private toaster: ToastrService,private translate: TranslateService) {
    this.arrowkeyLocation = 0;
  }

  selectCountryDDL(ddlName) {
    this.dllObject.emit(ddlName);
    this.isEnableSelectPostalCode.emit(true);
    this.isEnableSelectCity.emit(true);
    this.isEnableSelectProductType.emit(true);
    this.selectedValue = ddlName
    this.isOpen = !this.isOpen;
  }
  change() {
    this.isOpen = !this.isOpen;
    this.searchTerm = "";
    this.showDdl = false;
    this.isEnableSelectPostalCode.emit(false);
    this.isEnableSelectCity.emit(false);
    this.isEnableSelectProductType.emit(false);
  }

  search(e) {
    this.tempContent = this.ddlContent;
    if (e.target) {
      this.tempContent = this.tempContent.filter(item => {
        if (item.key != undefined) {
          e.stopPropagation();
          return item.key.toLowerCase().startsWith(e.target.value.toLowerCase());
        }
      })
      if (this.tempContent.length == 0) {
        this.tempContent = this.ddlContent;
        this.tempContent = this.tempContent.filter(item => {
          if (item.value != undefined) {
            e.stopPropagation();
            return item.value.toLowerCase().startsWith(e.target.value.toLowerCase());
          }
        })
      }

    }
    else {
      this.tempContent = this.tempContent.filter(item => {
        if (item.key != undefined) {
          return item.key.toLowerCase().startsWith(e.toLowerCase());
        }
      })
    }
    this.showDdl = true;
  }
  arrowkeyLocation: any;

  @HostListener('window:keyup.enter')
  changeByEnterkey() {
    
    if (this.foucsed) {
      this.foucsed = false;
      var _ddl = this.tempContent as any[];
      var selectedDdl = _ddl[this.arrowkeyLocation];
      if (selectedDdl) {
        this.selectCountryDDL(selectedDdl)
      }
      else {
        this.toaster.error(`${this.translate.instant('pages.createReceiptPage.errorMsgs.enterValidInput')}`);
      }
    }
    this.showDdl = false;
    this.searchTerm = "";
  }
  @HostListener('window:keydown', ['$event'])
  onarrowDown(event) {
    if (this.foucsed) {
      if (event.key == 'ArrowDown') {
        if (this.arrowkeyLocation < this.tempContent.length - 1)
          return this.arrowkeyLocation++;
      }
      else {
        if (event.key == 'ArrowUp') {
          if (this.arrowkeyLocation > 0)
            return this.arrowkeyLocation--;
        }
      }
    }
  }
  foucsed = false
  triggerFoucs(onFoucs) {
    this.foucsed = onFoucs;
  }

  ngOnInit() {
    this.tempContent = this.ddlContent;
    this.searchTerm = "";
  }

}
